import { createContext } from 'react';

import { PresencasResponse } from 'api/Assessor/evento';

import {
  IAssembleiasAssessorEvent,
  IAssembleiaAssessorLoadContas,
} from 'store/modules/AssembleiasAssessorReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';

interface AssembleiaAssociadoContext {
  evento: IAssembleiasAssessorEvent | null;
  contasDisponiveis?: Array<IAssembleiaAssessorLoadContas>;
  loadingEvento: boolean;
  loadingPautas: boolean;
  liberarEmLote: boolean;
  setLiberarEmLote: any;
  bloquearEvento: () => void;
  bloqueando: boolean;
  alterarSituacao: () => void;
  usuario?: IAuthUserReducer;
  atualizarPresencas: () => void;
  atualizandoPresencas: boolean;
  presencas: PresencasResponse;
  editarTransmissao: () => void;
  registraQuorum: () => void;
  startVoting: () => void;
  registrandoQuorum: boolean;
  startingVoting: boolean;
  setPagePautas: (value: number) => void;
  pagePautas: number;
  setPautas: (value: number) => void;
  loadPautas: (idEvento: number) => void;
}

export default createContext<AssembleiaAssociadoContext>({
  evento: null,
  loadingEvento: false,
  loadingPautas: false,
  liberarEmLote: false,
  setLiberarEmLote: () => {},
  bloquearEvento: () => {},
  bloqueando: false,
  alterarSituacao: () => {},
  atualizandoPresencas: false,
  atualizarPresencas: () => {},
  presencas: {
    contasCapital: 0,
    presentes: 0,
    convidados: 0,
    presentesAptos: 0,
    quorumAtingido: false,
    quantidadePessoasOnline: 0,
  },
  editarTransmissao: () => {},
  registraQuorum: () => {},
  startVoting: () => {},
  registrandoQuorum: false,
  startingVoting: false,
  setPagePautas: () => {},
  pagePautas: 0,
  setPautas: () => {},
  loadPautas: () => {},
});
